import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { apiInstance } from "./axiosApi";
import authHeader from "./authHeader";

// 🔹 Get All Workshop Testimonials
export const getWorkshopTestimonials = createAsyncThunk(
  "admin/allWorkshopTestimonials",
  async ({ page, limit, searchData }, { rejectWithValue }) => {
    try {
      let url = `/workshop-testimonial/all?page=${page}&limit=${limit}`;
      if (searchData) url += `&search=${searchData}`;
      const response = await apiInstance.get(url, { headers: authHeader() });
      return response;
    } catch (error) {
      return rejectWithValue(error.response?.data);
    }
  }
);

// 🔹 Add Workshop Testimonial
export const addWorkshopTestimonial = createAsyncThunk(
  "admin/addWorkshopTestimonial",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await apiInstance.post(`/workshop-testimonial/add`, payload, {
        headers: authHeader(),
      });
      return response;
    } catch (error) {
      return rejectWithValue(error.response?.data);
    }
  }
);

// 🔹 Edit Workshop Testimonial
export const editWorkshopTestimonial = createAsyncThunk(
  "admin/editWorkshopTestimonial",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await apiInstance.post(`/workshop-testimonial/edit`, payload, {
        headers: authHeader(),
      });
      return response;
    } catch (error) {
      return rejectWithValue(error.response?.data);
    }
  }
);

// 🔹 Get Single Workshop Testimonial
export const getSingleWorkshopTestimonial = createAsyncThunk(
  "admin/singleWorkshopTestimonial",
  async (testimonialId, { rejectWithValue }) => {
    try {
      const response = await apiInstance.get(`/workshop-testimonial/${testimonialId}`, {
        headers: authHeader(),
      });
      return response;
    } catch (error) {
      return rejectWithValue(error.response?.data);
    }
  }
);

// 🔹 Delete Workshop Testimonial
export const deleteWorkshopTestimonial = createAsyncThunk(
  "admin/deleteWorkshopTestimonial",
  async (selectedId, { rejectWithValue }) => {
    try {
      const response = await apiInstance.delete(`/workshop-testimonial/delete/${selectedId}`, {
        headers: authHeader(),
      });
      return response;
    } catch (error) {
      return rejectWithValue(error.response?.data);
    }
  }
);

// 🔹 Initial State
const initialState = {
  workshopTestimonialData: [],
  singleWorkshopTestimonial: {},
};

// 🔹 Slice
const workshopTestimonialSlice = createSlice({
  name: "workshopTestimonialSlice",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getWorkshopTestimonials.fulfilled, (state, action) => {
      state.workshopTestimonialData = action.payload.data;
    });
    builder.addCase(getSingleWorkshopTestimonial.fulfilled, (state, action) => {
      state.singleWorkshopTestimonial = action.payload.data;
    });
  },
});

export default workshopTestimonialSlice.reducer;
